import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Image } from '@codex/basics';
import { Close } from '@codex/organisms';
import { Device, DeviceProvider, Toggleable } from '@codex/gadgets';
import CompareProductTooltip from './CompareProductTooltip.jsx';

const CompareProductWrapper = styled.div`
  width: 100%
`;

const ProductTitle = styled.div`
  width: auto;
  max-width: calc(100% - 75px);
  max-height: 28px;
  overflow: hidden;
  display: inline-block;
  margin-top: 5px;
  @media only screen and (max-device-width: 1024px) {
    max-height: 25px;
    font-size: 10px;
  };
`;

const StyledClose = styled(Close)`
  position: absolute;
  top: 21%;
  right: 0;
`;

const HoverBridge = styled.div`
    position: absolute;
    bottom: -30px;
    left: 110px;
    height: 30px;
    width: 100px;
`;

export default function CompareProduct(props) {

  return (
    <DeviceProvider>
      <Device>
        {({ isDesktop }) => (
          <Toggleable closeOnPageScroll closeOnOutsideClick>
            {({ open, toggle, innerRef }) => (
              <CompareProductWrapper
                ref={innerRef}
                {...isDesktop ? { onMouseLeave: () => toggle(false) } : {}}
              >
                <a
                  className={'dc-compare-panel-item-link'}
                  {...{
                    [isDesktop ? 'onMouseEnter' : 'onClick']: (event) => {
                      event.preventDefault();
                      toggle(!open);
                    }
                  }}
                >
                  <Image
                    image={props.imageSrc}
                    alt={props.title ? props.title : ''}
                  />

                  <ProductTitle>
                    {props.brand}
                    {' '}
                    {props.title}
                  </ProductTitle>

                  <StyledClose onClose={props.onRemove} />
                </a>

                {open && (
                <div className={'dc-compare-panel-product__tooltip'}>
                  <CompareProductTooltip
                    imageUrl={props.imageSrc}
                    prices={props.prices}
                    title={props.title}
                    productUrl={props.url}
                    imageAlt={props.imageAlt}
                    isOutOfStock={props.isOutOfStock}
                    brand={props.brand}
                    translations={props.translations}
                    firstChild={props.firstChild}
                    onProductClick={props.onTooltipClick}
                  />
                  <HoverBridge />
                </div>
                )}
              </CompareProductWrapper>
            )}
          </Toggleable>
        )}
      </Device>
    </DeviceProvider>
  );
}

CompareProduct.displayName = 'CompareProduct';

CompareProduct.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
  imageSrc: PropTypes.string.isRequired,
  brand: PropTypes.string,
  imageAlt: PropTypes.string,
  isOutOfStock: PropTypes.bool.isRequired,
  onRemove: PropTypes.func,
  prices: PropTypes.objectOf(PropTypes.string).isRequired,
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  firstChild: PropTypes.bool,
  onTooltipClick: PropTypes.func
};

CompareProduct.defaultProps = {
  url: '#',
  brand: '',
  imageAlt: '',
  onRemove: () => {},
  firstChild: false,
  onTooltipClick: () => {}
};
